import "./Help.scss";
import React, {useEffect, useState} from 'react';
import { withRouter } from "../../helpers/withRouter";
import { _loading } from "../../actions/Loading";
import {connect, useDispatch} from "react-redux";
import Header from "../Panel/Header/header";
import Footer from "../Panel/Footer/footer";
import Config from "../../config"
import {default as _} from "../../helpers/Translate";

function Help(props) {
    const dispatch = useDispatch();
    const [url, setUrl] = useState("");

    useEffect(()=>{
        document.title = _.init("title_helpPage");
    }, [])

    useEffect(() => {
        switch (props.params.manual){
            case "user":
                setUrl(`${Config.baseUrl}common/manuals/user-manual.pdf`)
                break;
            case "report":
                setUrl(`${Config.baseUrl}common/manuals/report-manual.pdf`)
                break;
        }
    },[props.params]);

    const handleLoad = () =>{
        const help_viewer = document.querySelector(".Help");
        const iframe = document.querySelector("iframe");
        if (help_viewer && iframe){
            const height = Math.max(help_viewer.getBoundingClientRect().height - 12, iframe.getBoundingClientRect().height);
            iframe.style.height = `${height}px`
        }
        dispatch(_loading(false));
    }

    return (
        <>
            <Header page={"help"} />
            <div className={'Help'}>
                <div className={`help_viewer`}>
                    <iframe
                        id="iframe_help"
                        src={url}
                        width="100%"
                        min-height="600px"
                        frameBorder="0"
                        onLoad={handleLoad}
                    />
                </div>
            </div>
            <Footer/>
        </>
    );
}


const mapStateToProps = state => {
    const language = state.LangReducer.language;
    return {language};
};

export default connect(mapStateToProps)(withRouter(Help));